export default __webpack_public_path__ + "static/media/grabLogo.daf6cc5d.png";